// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_2321b27c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_eec68424",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_dfcc28ca",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_3518bf19",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_92700fe4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_ba969174",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_db72392a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_b4ef117d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_ec4105be",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_86c442ce",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_6af887d5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_15336c90",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_47971bad",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_b4805051",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_735715e4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_3d2db2d9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_e7ad816c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_2c5ef3f4",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_708625a1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_02b5803d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_4fe2831d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_a0f6ed0f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_d9c0d992",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_56119ad8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_2b82864a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_a89c1175",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_a0f424fc",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_ee1ac1a9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_5d3ad2b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_b6f26072",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_518e89aa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_39288ea4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_c98ce7ea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_5e0b0978",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_5baaea47",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_649cce2b",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_839e8235",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_1b0a2c27",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_b4cb33fe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_064d58c2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_e3df2771",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_63657471",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_3f514de4",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_082014e2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_ac3b0785",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_ff564233",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_e9e69868",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_8f129204",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_96aaf4dc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_c90c02fa",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_ef327b08",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_25451059",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_44b5f622",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_248c78e4",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_dcfbfaff",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_706f8331",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_2ff7b6f7",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_6c77c317",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_dba3e4e1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_d0c79c77",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_64fc6461",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_7ec25c22",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_96f40b31",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_42fe1326",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_b93bec73",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_7dece906",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_b61354a5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_e9b5e0c5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_152a4c5d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_13170ea5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_48c178ea",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_45058380",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_ca416d95",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_76e1b06a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_2a78b593",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_f3c353ac",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_68f81273",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_556f87de",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_e85e465e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_28a9bb41",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_560bfeaf",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8df3b6fa" /* webpackChunkName: "config_i18n_46config_46ts_8df3b6fa" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    name: "Français",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    name: "Español",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

